import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  ChangeDetectorRef,
  OnDestroy
} from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';

import * as AuthMethods from 'src/models/IAuth';
import { Location } from '@angular/common';
import { AuthService } from 'src/app/core/auth.service';
import { HtttpMethodErrors, UISections } from 'src/models/constants';
import { AbstractNotifiersService } from 'src/app/abstract-notifiers/abstract-notifiers.service';
import { Router } from '@angular/router';
import { DashboardService } from '../../+dashboard/dashboard.service';

@Component({
  selector: 'app-verify-account',
  templateUrl: './verify-account.component.html',
  styleUrls: ['./verify-account.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VerifyAccountComponent implements OnInit, OnDestroy {
  // @ViewChild('fst', { static: false }) fstInput: ElementRef;
  // @ViewChild('sec', { static: false }) secInput: ElementRef;
  // @ViewChild('thrid', { static: false }) thridInput: ElementRef;
  // @ViewChild('fourth', { static: false }) fourthInput: ElementRef;
  form: FormGroup;
  @Input() email: string;
  @Input() password: string;
  @Input() appName: string;
  @Input() countryIso: string;
  @Input() templateID: string;
  @Input() name: string;
  newTag = '';
  tacValue = '';
  waiting = false;
  hideResendCode = false;
  authServeceSubs = null;
  constructor(
    public authService: AuthService,
    public dashboard: DashboardService,
    private _ref: ChangeDetectorRef,
    public router: Router,
    private location: Location,
    private _abstractNotifiersService: AbstractNotifiersService
  ) {}

  ngOnInit() {
    const url = this.location.path();
    const urlPath = url.split('?');
    document.getElementById('1').focus();
    this.authServeceSubs = this.authService.authCollection$.subscribe(res => {
      this.form = new FormGroup({
        appName: new FormControl(res.appName),
        password: new FormControl(res.password),
        email: new FormControl(res.email),
        countryIso: new FormControl(res.countryIso),
        templateID: new FormControl(this.templateID),
        fst: new FormControl('', [
          Validators.required,
          Validators.maxLength(6)
        ]),
        tac: new FormControl(''),
        name: new FormControl(res.name)
      });

      if (
        res.token &&
        (res.appConfig == 0 || res.appConfig == 1) &&
        res.is_nandbox == 0 &&
        res.chatId &&
        urlPath[0] !== '/signup' &&
        urlPath[0] !== '/verifyCode'
      ) {
        this.router.navigate(['/app']);
        this.dashboard.setSection(UISections.APP);
      }
    });
  }
  get fst() {
    return this.form.get('fst');
  }
  onInputEntry(event, id) {
    const input = event.target;
  }

  setTacValue(value) {
    this.tacValue = value;
  }
  onSubmit() {
    this.waiting = true;
    this.authService
      .createAccount(this.form.value, this.tacValue)
      .subscribe(response => {
        const res = <AuthMethods.HttpResult>response;
        if (res.result === 0) {
          this.authService.createAccountSuccess(this.form.value.password);
          this.waiting = false;
        } else if (
          res.error === HtttpMethodErrors.WRONG_TAC ||
          res.error === HtttpMethodErrors.WRONG_TAC_2
        ) {
          this.form.setErrors({ wrongTac: true });
          this.waiting = false;
          this._ref.detectChanges();
        } else if (
          res.error === HtttpMethodErrors.PASSWORD_TOO_SHORT ||
          res.error === HtttpMethodErrors.PASSWORD_MUST_CONTAIN_LOWERCASE ||
          res.error === HtttpMethodErrors.PASSWORD_MUST_CONTAIN_UPPERCASE ||
          res.error === HtttpMethodErrors.PASSWORD_MUST_CONTAIN_DIGIT ||
          res.error === HtttpMethodErrors.PASSWORD_MUST_CONTAIN_SPECIAL ||
          res.error === HtttpMethodErrors.PASSWORD_MATCHES_PATTERN ||
          res.error === HtttpMethodErrors.PASSWORD_MATCHES_DICTIONARY ||
          res.error === HtttpMethodErrors.PASSWORD_TOO_LONG
        ) {
          this.form.setErrors({ patternIsNotMarch: true });
          this.waiting = false;
          this._ref.detectChanges();
        }
      });
  }
  reSend() {
    this.authService.getEmailTac(this.form.value).subscribe(response => {
      const res = <AuthMethods.HttpResult>response;
      if (res.result === 0) {
        this._abstractNotifiersService.showSnakbarNotifierMessage(
          'Verification code sent successfully',
          false
        );
        this.authService.emailTacSuccess(this.form.value);
        this._ref.detectChanges();
      }
    });
    this.hideResendCode = true;
    var timeLeft = 30;
    var elem = document.getElementById('countdown');
    elem.innerHTML = 'Resend Code in ' + timeLeft + ' seconds';
    timeLeft--;
    var timerId = setInterval(() => {
      if (timeLeft <= 0) {
        clearInterval(timerId);
        elem.innerHTML = '';
        this.hideResendCode = false;
        this._ref.detectChanges();
      } else {
        elem.innerHTML = 'Resend Code in ' + timeLeft + ' seconds';
        timeLeft--;
      }
    }, 1000);
  }
  pasteUrl(e) {
    const tac = e;
    const splitted = e.split('', 4);
    this.setValue(splitted, e);
  }

  setValue(splitted, e) {
    this.form.reset();
    this.form.setValue({
      fst: splitted[0],
      sec: splitted[1],
      third: splitted[2],
      fourth: splitted[3],
      appName: this.appName,
      password: this.password,
      email: this.email,
      countryIso: this.countryIso,
      templateID: this.templateID,
      tac: e
    });
    this._ref.detectChanges();
  }

  routeBack() {
    this.router.navigate(['/signup']);
  }

  ngOnDestroy(): void {
    if (this.authServeceSubs) {
      this.authServeceSubs.unsubscribe();
    }
  }
}
